<template>
    <div class="default-file" data-vue-handed :class="{error : errors.length}">
        <div class="default-file__input">
            <input class="default-file__input-input" :multiple="multiple" @change="setValue" :name="name" type="file"
                   :id="id" :accept="accept">
            <label class="default-file__input-label" :for="id">
                <span>{{ placeholder }}</span>
            </label>
        </div>
        <div class="default-file__error" v-if="errors.length">
            <span>{{ errors[0].$message }}</span>
        </div>
        <div class="default-file__preview">
            <div class="preview">
                <div class="preview__item" v-for="file in value" :key="file.name" :title="file.name">
                    <div class="preview__item-img" :class="{'preview__item-img--file' : !getFileData(file).isImage}"
                         :data-ext="getFileData(file).ext"
                         :style="getFileData(file).isImage ? `background-image : url(${getFileData(file).url})` : ''">
                        <span class="preview__item-del" @click.prevent="deleteFile(file)"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getFileData} from "@/mixins/fileData";

export default {
    name: "InputFile",
    emits: ['update:modelValue'],
    mixins: [getFileData],
    props: {
        modelValue: {
            type: FileList,
            default: null
        },
        placeholder: {
            type: String,
            default: 'Выберите файл'
        },
        accept: {
            type: String,
            default: 'image/*'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        errors: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },
    },
    methods: {
        setValue(e) {
            const files = Array.from(e.target.files);
            const dt = new DataTransfer();
            files.forEach((file) => dt.items.add(file));

            if (dt.files !== undefined && dt.files[0] !== undefined) {
                let flagValid = true;
                let file = dt.files[0];
                let maxFileSize = 20000000;
                let acceptString = this.accept.replaceAll('.', '');
                let validFileName = acceptString.split(',');
                validFileName = validFileName.map(s => s.trim());

                if (file) {
                    if (file.size > maxFileSize) {
                        flagValid = false;
                        // alert('Превышен допустимый размер файла в 20МБ');
                        window.toast.error('Ошибка загрузки файла', 'Превышен допустимый размер файла в 20МБ');
                    }

                    let parts = file.name.split('.');
                    let ext = parts[parts.length - 1];

                    if (
                        validFileName.indexOf(ext) === -1
                    ) {
                        flagValid = false;
                        // alert('Некорректный формат файла');
                        window.toast.error('Ошибка загрузки файла', 'Некорректный формат файла');
                    }
                }

                if (flagValid) {
                    this.value = dt.files;
                    e.target.value = null;
                }
            }
        },
        deleteFile(fileObj) {
            const {name} = fileObj;
            const files = Array.from(this.value).filter((file) => file.name !== name);
            const dt = new DataTransfer();
            files.forEach((file) => dt.items.add(file));

            this.value = dt.files;
        },
    }
}
</script>

<style scoped>

</style>